import { render, staticRenderFns } from "./ModattaStepInteractionPostback.vue?vue&type=template&id=ca25160e"
import script from "./ModattaStepInteractionPostback.vue?vue&type=script&lang=js"
export * from "./ModattaStepInteractionPostback.vue?vue&type=script&lang=js"
import style0 from "./ModattaStepInteractionPostback.vue?vue&type=style&index=0&id=ca25160e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports